import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ApiResponseStatus } from '../domain/api';

const initialState: ApiResponseStatus = {
    code: 0,
    requestType: '',
    text: '',
};

const apiResponseStatusSlice = createSlice({
    initialState,
    name: 'apiResponseStatus',
    reducers: {
        setApiResponseStatus: (state, action: PayloadAction<ApiResponseStatus | null>) => {
            // Clear the API response status before setting a new one
            state.code = 0;
            state.requestType = '';
            state.text = '';

            if (action.payload) {
                state.code = action.payload.code;
                state.requestType = action.payload.requestType;
                state.text = action.payload.text;
            }
        },
    },
});

export const { setApiResponseStatus } = apiResponseStatusSlice.actions;
export default apiResponseStatusSlice.reducer;
